import { History } from "lucide-react";
import { daDate } from "@/lib/date";

export const MovedBadge = ({ history, testid, className = "" }) => {
  const h = history || [];
  if (!h.length) return null;
  const last = h[h.length - 1];
  const title = `Deadline rykket ${h.length} ${h.length === 1 ? "gang" : "gange"}: ${daDate(h[0].from)} → ${daDate(last.to)}\nÅrsag: ${last.reason || "—"}`;
  return (
    <span data-testid={testid} title={title} className={`inline-flex items-center gap-1 rounded-md bg-[#F1DEDA] text-[#A83232] border border-[#E9C9C3] px-1.5 py-0.5 text-[10px] font-semibold align-middle cursor-help shrink-0 ${className}`}>
      <History className="h-3 w-3" strokeWidth={2} /> Rykket ×{h.length}
    </span>
  );
};
